/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLocationPinS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M12 2c1.5 0 2.893.472 4.05 1.281 2.895 2.025 3.71 6.066 2.22 9.339-.928 2.034-2.738 5.111-6.27 9.38-3.532-4.269-5.342-7.346-6.27-9.38-1.49-3.272-.675-7.314 2.22-9.339A7.035 7.035 0 0 1 12 2zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgLocationPinS as LocationPinS };
